module.exports = __webpack_public_path__ + "static/media/h_3.b1283b6a.jpg";